// Post-supabase-native: tRPC client is gone. The shim throws plain Error.
// Zod-flavoured error parsing is no longer applicable; return undefined.
import { ZodError } from 'zod';

export function trpcClientErrorToZodError(_e: unknown): ZodError | undefined {
  return undefined;
}
